import _ from 'lodash';

/**
 * A helper to format strings to title case
 */
export const titleCase = (str?: string | null): string => _.startCase(_.toLower(str || ''));
